class LoginModal {
    constructor() {
        this.modal = document.getElementById('login-modal');
        this.openButtons = document.querySelectorAll('.login-open-button');
        this.closeButtons = document.querySelectorAll('.login-modal-close-button');

        this.init();
    }

    init() {
        if (!this.modal) {
            console.warn('Login modal element not found');
            return;
        }

        this.initOpenButtons();
        this.initCloseButtons();

        console.log('Login modal initialized');
    }

    /**
     * Open Modal
     */
    initOpenButtons() {
        this.openButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.openModal();
            });
        });
    }

    /**
     * Close Modal
     */
    initCloseButtons() {
        if (!this.closeButtons) return;

        this.closeButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.closeModal();
            });
        });

        // Close modal on outside click
        this.modal.addEventListener('click', (e) => {
            if (e.target === this.modal) {
                this.closeModal();
            }
        });
    }

    openModal() {
        this.modal.scrollTop = 0;
        this.modal.classList.add('login-modal--active');
        document.body.classList.add('login-modal-open');
    }

    closeModal() {
        this.modal.classList.remove('login-modal--active');
        document.body.classList.remove('login-modal-open');
    }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    window.loginModal = new LoginModal();
});